import React, { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

import { Loader } from 'ui';
import { EventsProduct } from '../components/EventsProduct/EventsProduct';
import { EventsSortSelect } from '../components/EventsSortSelect/EventsSortSelect';
import { EventsFilters } from '../components/EventsFilters/EventsFilters';
import { getEvents } from '../selectors/eventsSelectors';
import { fetchEventsAction } from '../store/eventsActions';

const useStyle = makeStyles(() => ({
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  counter: {
    fontSize: 15,
    marginRight: 20,
    marginBottom: 2,
    fontWeight: 500,
  },
  button: {
    height: 45,
    marginLeft: 10,
  },
  noDataText: {
    fontSize: 18,
  },
}));

const Events: FC = () => {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();

  // @ts-ignore
  const { events: allEvents } = useSelector(({ events }) => events);
  const events = useSelector(getEvents);

  useEffect(() => {
    dispatch(fetchEventsAction());
  }, [dispatch]);

  if (events.isPending) {
    return <Loader center />;
  }

  return <>
    <Box my={2}>
      <EventsFilters />
    </Box>
    <Box mb={2}>
      <Grid container justifyContent="space-between">
        <Grid item className={classes.title}>
          <Typography variant="h5">{t('Events')}</Typography>
        </Grid>
        <Grid item>
          <Box display="flex" alignItems="center">
            <Typography component="span" className={classes.counter}>
              {events.data.length} of {allEvents.data.length}
            </Typography>
            <EventsSortSelect />
          </Box>
        </Grid>
      </Grid>
    </Box>
    <Paper elevation={3}>
      {events.data.length ? (
        <Box padding={6}>
          {events.data.map(item => (
            <EventsProduct data={item} key={item.id} />
          ))}
        </Box>
      ) : (
        <Box padding={3}>
          <Typography variant="body1" className={classes.noDataText}>
            {t('No products found')}
          </Typography>
        </Box>
      )}
    </Paper>
  </>;
};

export { Events };
